// import constant
import {
    SET_USER_SETTING,RESET_ALL
} from '../constant';

const initialState = {
};

const userSetting = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_SETTING:
            return {
                ...state,
                ...action.data
            };
            case RESET_ALL: {
                return initialState
                };
        default:
            return state;
    }

}

export default userSetting;